import { Inject, Injectable } from '@angular/core';
import { REQUEST_ACTION, REQUEST_SOURCE } from '@common/util-foundation';
import { ConfigAdapter } from '@common/util-models';

@Injectable()
export class RequestSourceConfigAdapter implements ConfigAdapter {
  constructor(
    @Inject(REQUEST_SOURCE) private requestSource: string,
    @Inject(REQUEST_ACTION) private action: string
  ) {}

  getConfig(): { catalogueStore: string; action: string } {
    return {
      catalogueStore: this.requestSource,
      action: this.action,
    };
  }
}
